class LogoMarquee extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.highlights-marquee__track');
    this.position = 0;
    this.isDragging = false;
    this.startX = 0;
    this.startPosition = 0;
    this.loopWidth = 0;
    this.speed = 1; // overridden in connectedCallback from data attribute
    this.rafId = null;

    this.tick = this.tick.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
  }

  connectedCallback() {
    this.measure();
    this.resizeObserver = new ResizeObserver(() => this.measure());
    this.resizeObserver.observe(this);

    this.addEventListener('pointerdown', this.onPointerDown);
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const autoplayDesktop = this.dataset.autoplayDesktop !== 'false';
    const autoplayMobile = this.dataset.autoplayMobile !== 'false';
    const autoplayEnabled = isMobile ? autoplayMobile : autoplayDesktop;
    this.speed = parseFloat(this.dataset.speed) || 1;

    if (autoplayEnabled && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.rafId = requestAnimationFrame(this.tick);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  measure() {
    const firstGroup = this.track.children[0];
    this.loopWidth = firstGroup ? firstGroup.getBoundingClientRect().width : 0;
  }

  tick() {
    if (!this.isDragging) {
      this.position -= this.speed;
      this.wrap();
      this.render();
    }
    this.rafId = requestAnimationFrame(this.tick);
  }

  wrap() {
    if (this.loopWidth <= 0) return;
    while (this.position <= -this.loopWidth) this.position += this.loopWidth;
    while (this.position > 0) this.position -= this.loopWidth;
  }

  render() {
    this.track.style.transform = `translateX(${this.position}px)`;
  }

  onPointerDown(event) {
    this.isDragging = true;
    this.startX = event.clientX;
    this.startPosition = this.position;
    this.classList.add('highlights-marquee__slider--dragging');
  }

  onPointerMove(event) {
    if (!this.isDragging) return;
    const delta = event.clientX - this.startX;
    this.position = this.startPosition + delta;
    this.wrap();
    this.render();
  }

  onPointerUp() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.classList.remove('highlights-marquee__slider--dragging');
  }
}

customElements.define('logo-marquee', LogoMarquee);

class GradientTextCycler extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.highlights-marquee__text'));
    if (this.items.length < 2) return;

    this.activeIndex = 0;
    this.items[0].classList.add('highlights-marquee__text--active');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.timer = setInterval(() => this.next(), 2200);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  next() {
    this.items[this.activeIndex].classList.remove('highlights-marquee__text--active');
    this.activeIndex = (this.activeIndex + 1) % this.items.length;
    this.items[this.activeIndex].classList.add('highlights-marquee__text--active');
  }
}

customElements.define('gradient-text-cycler', GradientTextCycler);
